import { createContext } from 'react';

const SelectedStationMap = createContext();

export default SelectedStationMap;
